import React from 'react';
import { Translation } from 'react-i18next';

export const TABS = {
  DETAILS: 'details',
  PRINCIPALS: 'users',
  PENDING_INVITATIONS: 'pending-invitations',
  JOIN_REQUESTS: 'join-requests',
  APP_SUBSCRIPTIONS: 'app-subscriptions',
  USER_GROUPS: 'user-groups',
  IDENTIFICATIONCODES: 'identificationcodes',
};

export const PRINCIPAL_TABS = {
  DETAILS: 'details',
  ROLES: 'roles',
  ACCOUNTS: 'accounts',
};

export const ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
};

export const CONTACT_ACTIONS = {
  CREATE_CONTACT: 'create-contact',
  REMOVE_CONTACT: 'remove-contact',
  EDIT_CONTACT: 'edit-contact',
};

export const USER_GROUP_ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
  MEMBERS: 'members',
};

export const PRINCIPAL_ACTIONS = {
  INVITE: 'invite',
  EDIT: 'edit',
  DETAILS: 'details',
  RESET: 'reset',
};

export const PRINCIPAL_FORM_NAME = 'principalForm';

export const PRINCIPAL_STATES = {
  ACTIVE: 1,
  INVITED: 2,
  DISABLED: 3,
  LOCKEDOUT: 4,
  DELETED: 5,
  PASSWORDTORESET: 6,
  PENDING: 7,
};

export const PRINCIPAL_STATES_OPTIONS = [
  {
    key: PRINCIPAL_STATES.ACTIVE,
    value: PRINCIPAL_STATES.ACTIVE,
    text: <Translation>{t => t('active')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.INVITED,
    value: PRINCIPAL_STATES.INVITED,
    text: <Translation>{t => t('invited')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.DELETED,
    value: PRINCIPAL_STATES.DELETED,
    text: <Translation>{t => t('deleted')}</Translation>,
  },
  {
    key: PRINCIPAL_STATES.PENDING,
    value: PRINCIPAL_STATES.PENDING,
    text: <Translation>{t => t('pending')}</Translation>,
  },
];

export const INFINITE_SCROLL = { loader: 'blocked' };

export const ORGANISATIONS_RESOURCE = 'organisations';
export const ORGANISATION_RESOURCE = 'organisation';
export const CREATE_ORGANISATION_RESOURCE = 'createOrganisation';
export const UPDATE_ORGANISATION_RESOURCE = 'updateOrganisation';
export const REMOVE_ORGANISATION_RESOURCE = 'removeOrganisation';

export const REMOVE_ORGANISATION_LOGO_RESOURCE = 'removeOrganisationLogo';

export const PRINCIPALS_RESOURCE = 'principals';
export const PRINCIPAL_RESOURCE = 'principal';
export const CREATE_PRINCIPAL_RESOURCE = 'createPrincipal';
export const UPDATE_PRINCIPAL_RESOURCE = 'updatePrincipal';
export const REMOVE_PRINCIPAL_RESOURCE = 'removePrincipal';

export const LINK_IDENTITY_RESOURCE = 'linkIdentity';
export const UNLINK_IDENTITY_RESOURCE = 'unlinkIdentity';

export const SEARCH_PRINCIPALS_RESOURCE = 'searchPrincipals';

export const AVAILABLE_ROLES_RESOURCE = 'availableRoles';

export const APP_SUBSCRIPTIONS_RESOURCE = 'appSubscriptions';
export const AVAILABLE_APP_SUBSCRIPTIONS_RESOURCE = 'availableAppSubscriptions';
export const CREATE_APP_SUBSCRIPTION_RESOURCE = 'createAppSubscription';
export const UPDATE_APP_SUBSCRIPTION_RESOURCE = 'updateAppSubscription';
export const REMOVE_APP_SUBSCRIPTION_RESOURCE = 'removeAppSubscription';

export const ORGANISATION_CONTACTS_RESOURCE = 'organisationContacts';
export const ORGANISATION_CONTACT_RESOURCE = 'organisationContact';
export const CREATE_ORGANISATION_CONTACT_RESOURCE = 'createOrganisationContact';
export const UPDATE_ORGANISATION_CONTACT_RESOURCE = 'updateOrganisationContact';
export const REMOVE_ORGANISATION_CONTACT_RESOURCE = 'removeOrganisationContact';

export const USER_GROUPS_RESOURCE = 'userGroups';
export const USER_GROUP_RESOURCE = 'userGroup';
export const CREATE_USER_GROUP_RESOURCE = 'createUserGroup';
export const UPDATE_USER_GROUP_RESOURCE = 'updateUserGroup';
export const REMOVE_USER_GROUP_RESOURCE = 'removeUserGroup';

export const ORGANISATION_USER_GROUPS_RESOURCE = 'organisationUserGroups';

export const USER_GROUP_MEMBERS_RESOURCE = 'userGroupMembers';
export const CREATE_USER_GROUP_MEMBER_RESOURCE = 'createUserGroupMember';
export const REMOVE_USER_GROUP_MEMBER_RESOURCE = 'removeUserGroupMember';

export const ORGANISATION_COMMUNITIES_RESOURCE = 'organisationCommunities';

export const JOIN_REQUESTS_RESOURCE = 'principalJoinRequests';
export const JOIN_REQUEST_RESOURCE = 'joinRequest';
export const ACCEPT_JOIN_REQUEST_RESOURCE = 'acceptJoinRequest';
export const DENY_JOIN_REQUEST_RESOURCE = 'denyJoinRequest';

export const APP_SUBSCRIPTION_ACTIONS = {
  NEW: 'new',
  NEW_FEATURE: 'new-feature',
  EDIT_FEATURE: 'edit-feature',
};

export const JOIN_REQUEST_ACTIONS = {
  ACCEPT_JOIN_REQUEST: 'accept-join-request',
  EDIT_JOIN_REQUEST: 'edit-join-request',
};

export const PENDING_INVITATIONS_RESOURCE = 'pendingInvitations';
export const RESEND_INVITATION_RESOURCE = 'resendInvitation';

export const GLOBAL_COMMUNITY_OPTION = {
  value: 'GLOBAL',
  key: 'GLOBAL',
  text: <Translation>{t => t('global')}</Translation>,
};

export const ASSIGNED_ROLES_TYPES = {
  USER_GROUP: 'UserGroup',
  PRINCIPAL_ROLE: 'PrincipalRole',
};
